import { useRef, useState } from 'react';
import api from '@/utils/api';
import { documentErrorCode, documentExtension, validateDocument } from './documentUploadConfig';

export const useDocumentUpload = (config, onUploaded) => {
  const busy = useRef(false);
  const [state, setState] = useState({ status: 'idle', progress: 0, name: '', error: null });

  const upload = async (file) => {
    if (!file || busy.current) return;
    const invalid = validateDocument(file, config.extensions);
    if (invalid) {
      setState({ status: 'error', progress: 0, name: file.name, error: invalid });
      return;
    }
    busy.current = true;
    setState({ status: 'uploading', progress: 0, name: file.name, error: null });
    try {
      const body = new FormData();
      const filename = file.name.trim();
      body.append('file', file, filename.includes('.') ? filename : `${filename}.${documentExtension(file)}`);
      const { data } = await api.post(`/upload/${config.type}`, body, {
        timeout: 300000,
        onUploadProgress: ({ loaded, total }) => {
          const progress = total ? Math.min(100, Math.round(loaded / total * 100)) : 0;
          setState(current => ({ ...current, progress }));
        },
      });
      if (typeof data?.[config.responseField || config.field] !== 'string') throw new Error('Missing file confirmation');
      // Only update document fields; never reload/overwrite unsaved profile text.
      onUploaded(config, data);
      setState({ status: 'success', progress: 100, name: file.name, error: null });
    } catch (error) {
      setState({ status: 'error', progress: 0, name: file.name, error: documentErrorCode(error) });
    } finally {
      busy.current = false;
    }
  };

  return { state, upload };
};